<template>
  <button
    v-on:click="buttonClick"
    class="tooltip"
  >
    <slot v-if="on" name="on"></slot>
    <slot v-else name="off"></slot>
    <Tooltip :text="on ? tooltipTextOn : tooltipTextOff" />
  </button>
</template>

<script>
import Tooltip from '@/components/common/Tooltip.vue';
export default {
  name: 'layer-visible-button',
  components: {
    Tooltip,
  },
  props: {
    map: Object,
    layerName: String,
    tooltipTextOn: String,
    tooltipTextOff: String,
  },
  computed: {
    on () {
      return this.getLayerVisible();
    },
  },
  methods: {
    getLayer () {
      var ln = this.layerName;
      return this.map && this.map.getLayers().getArray()
        .find(function (l) {
          return l.get('title') === ln;
        });
    },
    getLayerVisible () {
      return this.getLayer() && this.getLayer().get('visible');
    },
    buttonClick () {
      var l = this.getLayer();
      this.getLayerVisible()
        ? l.setVisible(false)
        : l.setVisible(true);
    },
  },
};
</script>

<style scoped>
button {
  z-index:3;
  width: 50px;
  height: 50px;
  cursor: pointer;
  border: none;
  background: transparent;
  padding: 0;
  text-decoration: none;
  box-shadow: 0 0 8px 0 rgba(175,186,213,0.30);
}
button:focus {outline:0;}
</style>
